var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ChatForm", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: _vm.myChatList.length,
        expression: "myChatList.length",
      },
    ],
    attrs: { type: "my-chat", item: _vm.allMyChats },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }